<form (ngSubmit)="confirm()" [formGroup]="form" class="flex flex-col gap-4">
<div class="flex flex-col lg:flex-row gap-2">

  <h3>Cerrar plan actual <br/> y abrir nuevo</h3>

  <div class="ml-auto mb-auto pt-2 w-fit">
    <div class="outline warning truncate !py-1 !px-2 cd-text-b4 flex flex-row gap-2">
      <div class="bg-yellow-300 rounded-full h-4 w-4 my-auto"></div>
      <span class="truncate">En espera</span>
    </div>
  </div>
</div>

<div class="flex flex-col gap-3 w-full">

  <p>Vas a cerrar el plan actual (plan 2024) y a iniciar el siguiente.
    Una vez se inicie este proceso, no podrá revertirse.
    Por favor, introduce los datos del siguiente plan.</p>

  <div class="form-control">
    <label class="text-neutral-900" for="name">Nombre del nuevo plan</label>
    <div class="input-icon">
      <input autocomplete="off" id="name" formControlName="name" placeholder="Por defecto: Plan (año siguiente)" type="text">
    </div>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="name">Duración del nuevo plan (En el paso 4 se confirma)</label>
    <core-datepicker formControlName="dateRange" [range]="true" [reverse]="true"
                     class="!py-2" placeholder="01/01/2025 - 31/12/2025"/>
  </div>

  <div class="form-control flex-1 w-full">
    <label class="text-neutral-900" for="name">Descripción</label>
    <textarea id="description" formControlName="description" placeholder="Placeholder" rows="3"></textarea>
    <div class="feedback flex items-center justify-between px-2">
      <span class="cd-text-b4 text-neutral-500">Helper text</span>
      <span class="cd-text-b4 text-neutral-500">0/100</span>
    </div>
  </div>

  <div class="form-control flex-1 w-full">
    <label class="text-neutral-900" for="name">Objetivos</label>
    <textarea id="description" formControlName="goals" placeholder="Placeholder" rows="3"></textarea>
    <div class="feedback flex items-center justify-between px-2">
      <span class="cd-text-b4 text-neutral-500">Helper text</span>
      <span class="cd-text-b4 text-neutral-500">0/100</span>
    </div>
  </div>

</div>

@if (errorMessage) {
  <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
}

<div class="w-full flex flex-row items-center gap-4">
  <button type="submit"
          class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/send.svg">
    <span class="hidden lg:block cd-text-md truncate">
      {{ isSubmitting ? 'Guardando...' : 'Cerrar plan actual' }}
    </span>
  </button>

  <button (click)="close()"
          class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/x.svg">
    <span class="hidden lg:block cd-text-md truncate capitalize">Cancelar</span>
  </button>
</div>
</form>
